// extracted by mini-css-extract-plugin
module.exports = {"footer":"Footer_footer__1YSpw","box":"Footer_box__1Z6SB","social":"Footer_social__1Q4Vs"};